import { Fragment } from 'react';
import HostGroupSummary from './host-group-summary';
import HostUserSummary from './host-user-summary';
import type { Event } from '../types/Event';
import type { EventSeries } from '../types/EventSeries';

type Props = {
  event: Event | EventSeries;
};

const HostSummaries = ({ event }: Props) => {
  const { hostType, user, group } = event;
  return (
    <Fragment>
      {hostType === 'User' && user && (
        <HostUserSummary user={user} />
      )}
      {group && (
        <HostGroupSummary group={group} />
      )}
    </Fragment>
  );
}

export default HostSummaries;
